<template>
    <aside class="bg-black aside-md hidden-print hidden-xs" id="nav">
    <section class="vbox">
        <section class="w-f scrollable">
            <div class="slim-scroll" data-height="auto" data-disable-fade-out="true" data-distance="0" data-size="10px" data-railOpacity="0.2">
               
                <!-- nav -->
                <nav class="nav-primary hidden-xs">
                    <div class="text-muted text-sm hidden-nav-xs padder m-t-sm m-b-sm">  </div>
                    <ul class="nav nav-main" data-ride="collapse">
                        <li></li>
                            <li class="<?php echo $Css ?>">
                                <router-link to="/dashboard"> <i class="fa fa-tachometer icon"> </i> <span class="font-normal">Dashboard</span></router-link>
                            </li>
                           
                        <li class="treeview">
                            <a href="#">
                                <i class="fa fa-cog"></i> <span>Master Data</span>
                                <span class="pull-right-container">
                                    <i class="fa fa-angle-left pull-right"></i>
                                </span>
                            </a>
                            <ul class="treeview-menu">
                                <li> <router-link to="/supplier"><i class="fa fa-circle-o"></i>  Suppliers </router-link></li>
                                <li> <router-link to="/product"><i class="fa fa-circle-o"></i>  Products </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/customer"><i class="fa fa-circle-o"></i>  Customers </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/brand"><i class="fa fa-circle-o"></i>  Brands </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/category"><i class="fa fa-circle-o"></i>  Categories </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/uom"><i class="fa fa-circle-o"></i>  UOM </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/payment-terms"><i class="fa fa-circle-o"></i>  Payment Terms </router-link></li>
                                <li v-if="isAdmin"> <router-link to="/vendor-types"><i class="fa fa-circle-o"></i>  Vendor Types </router-link></li>
                            
                            </ul>
                        </li> 
                        <li v-if="isAdmin" class="">
                            <router-link to="/project"> <i class="fa fa-money"> </i> <span class="font-normal">Project Management</span></router-link>
                        </li> 
                        <li v-if="isAdmin" class="">
                            <router-link to="/site"> <i class="fa fa-building"> </i> <span class="font-normal">Site Management</span></router-link>
                        </li> 
                        <li class="">
                            <router-link to="/purchase"> <i class="fa fa-truck"> </i> <span class="font-normal">Purchase Management</span></router-link>
                        </li> 
                        <li class="">
                            <router-link to="/grn"> <i class="fa fa-truck"> </i> <span class="font-normal">Goods Received Note</span></router-link>
                        </li>
                        <li class="">
                            <router-link to="/od"> <i class="fa fa-truck"> </i> <span class="font-normal">Delivery Out</span></router-link>
                        </li>
                        <li v-if="isAdmin" class="">
                                <router-link to="/user"> <i class="fa fa-users"> </i> <span class="font-normal">User Management</span></router-link>
                        </li>
                           
                        <li v-if="isAdmin" class="treeview">
                            <a href="#">
                                <i class="fa fa-list"></i> <span>Reports</span>
                                <span class="pull-right-container">
                                    <i class="fa fa-angle-left pull-right"></i>
                                </span>
                            </a>
                            <ul class="treeview-menu">
                                <li> <router-link to="/purchase-report"><i class="fa fa-circle-o"></i> Purchase Orders </router-link></li>
                                <li> <router-link to="/product-list"><i class="fa fa-circle-o"></i> Product List </router-link></li>
                                <li> <router-link to="/supplier-list"><i class="fa fa-circle-o"></i> Supplier List </router-link></li>
                                <li> <router-link to="/project-list"><i class="fa fa-circle-o"></i> Project List </router-link></li>
                                <li> <router-link to="/location-list"><i class="fa fa-circle-o"></i> Location List </router-link></li>        
                            </ul>
                        </li> 
                    </ul>

                </nav>
                <!-- / nav --> 
            </div>
        </section>
        <footer class="footer hidden no-padder text-center-nav-xs"> <a href="" data-toggle="ajaxModal" class="btn btn-icon icon-muted btn-inactive pull-right m-l-xs m-r-xs hidden-nav-xs"> <i class="i i-logout"></i> </a> <a href="#nav" data-toggle="class:nav-xs" class="btn btn-icon icon-muted btn-inactive m-l-xs m-r-xs"> <i class="i i-circleleft text"></i> <i class="i i-circleright text-active"></i> </a> </footer>
    </section>
</aside>

</template>


<script>

export default {
  name: 'Sidebar',
  computed:{
    isAdmin: function () {
        if (this.$store.state.user && this.$store.state.user.user_role == this.$store.state.userroleAdmin) {
            return true
        } else {
            return false
        }
    }
  }
}
</script>
